import React from "react";
import { Box, Card, CardContent, Typography, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PromotionHistoryLogPanel from "../../components/student/PromotionHistoryLogPanel";

export default function PromotionHistory() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} aria-label="Back">
          <ArrowBack />
        </IconButton>
        <Typography variant="h6" fontWeight={700}>
          Promotion history
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <PromotionHistoryLogPanel classOptions={[]} />
        </CardContent>
      </Card>
    </Box>
  );
}

